import React from 'react';
import './styles.scss';
import cn from 'classnames';
import { Col, Row } from 'antd';
import { Image, MyButton } from 'components/Atoms';
import { useCurrencyConversion } from 'hooks/useCurrencyConversion';
import { TagIcon } from 'components/Atoms/Icon';
import {
  CREATIVE_TYPE,
  getSpecTemplateDesc,
} from 'components/Pages/Library/components/Creatives/constanst';
import { useTrackingAbandonedCarts } from 'hooks/usePayment';
import { FormattedMessage } from 'react-intl';

const CartItem = ({ type = 'badge', item, removeCartItem }) => {
  const trackingAbandonedCarts = useTrackingAbandonedCarts();
  const { simpleFormatUSD } = useCurrencyConversion(item.price);
  const handleTrackingRemoveCreative = (item) => {
    trackingAbandonedCarts.mutate({
      cartContents: [item.name],
      cartTotalAmount: item.price,
    });
    removeCartItem(item);
  };

  const image =
    item.type === CREATIVE_TYPE.FULLSET
      ? item.templateFullSetDetails[0].file.preview
      : item.thumbnail;

  return (
    <div className={cn('cart-item-wrapper', type)}>
      <Row gutter={[15, 0]} wrap={false}>
        <Col flex="none">
          <Image className="cart-item-image" src={image} />
        </Col>
        <Col flex="auto">
          <Row gutter={[15, 0]} wrap={false} align="middle">
            <Col flex="auto">
              <div
                className={cn('name', {
                  'h-40 text-2-line': type === 'badge',
                  'text-1-line': type !== 'badge',
                })}
              >
                {item.name}
              </div>
            </Col>
            {type !== 'badge' && (
              <Col flex="none">
                <div className="price-tag">
                  <span>{simpleFormatUSD(item.price)}</span>
                  <TagIcon />
                </div>
              </Col>
            )}
          </Row>
          <div className="spec text-1-line">
            {getSpecTemplateDesc(item.type, item.templateSpec)}
          </div>
          {type === 'badge' && (
            <div className="price">{simpleFormatUSD(item.price)}</div>
          )}
          {type === 'cartPage' && (
            <div className="removebtn">
              <MyButton
                type="link"
                onClick={() => handleTrackingRemoveCreative(item)}
              >
                <FormattedMessage id="common.remove" />
              </MyButton>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CartItem;
